// ============================================
// Dispatcher API Service (Read-Only)
// Hits /api/dispatcher/* endpoints
// Token handled by api.js interceptor
// ============================================

import api from './api';

const dispatcherService = {
    // ── Dashboard Stats ─────────────────────
    getStats: () => api.get('/dispatcher/stats'),

    // ── Drivers (read-only) ─────────────────
    getDrivers: (params) => api.get('/dispatcher/drivers', { params }),

    // ── PAs (read-only) ─────────────────────
    getPAs: (params) => api.get('/dispatcher/pas', { params }),

    // ── Routes (read-only) ──────────────────
    getRoutes: (params) => api.get('/dispatcher/routes', { params }),

    // ── Vehicles (read-only) ────────────────
    getVehicles: (params) => api.get('/dispatcher/vehicles', { params }),

    // ── Jobs (read-only) ────────────────────
    getJobs: (params) => api.get('/dispatcher/jobs', { params }),

    // ── Schools (read-only) ─────────────────
    getSchools: (params) => api.get('/dispatcher/schools', { params }),

    // ── Children (read-only) ────────────────
    getChildren: (params) => api.get('/dispatcher/children', { params }),

    // ── Reassignment & Tracking ────────────────
    reassignRoute: (id, data) => api.put(`/dispatcher/reassign-route/${id}`, data),
    assignJobToDriver: (id, driverId) => api.patch(`/dispatcher/jobs/${id}/assign-driver`, { driverId }),
    unassignJob: (id) => api.patch(`/dispatcher/jobs/${id}/unassign-driver`),
    assignVehicleToDriver: (id, payload) => api.patch(`/dispatcher/drivers/${id}/assign-vehicle`, typeof payload === 'object' && payload !== null ? payload : { vehicleId: payload }),
    generateTrackingLink: (id) => api.post(`/dispatcher/routes/${id}/tracking-link`),
};

export default dispatcherService;
